var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$parent.content_type === 'pagebuilder'),expression:"this.$parent.content_type === 'pagebuilder'"}],staticClass:"uk-width-1-1 uk-height-1-1 uk-container-large uk-padding",attrs:{"uk-height-viewport":""}},[_c('div',{class:[ _vm.classes ],domProps:{"innerHTML":_vm._s(_vm.layout)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }